const Mission = () => (
  <section id="mission" className="py-16 md:py-24">
    <div className="container mx-auto">
      <div>
        <h2 className="text-4xl md:text-5xl font-semibold">Mission</h2>
        <p className="mt-3 text-lg md:text-xl text-muted-foreground max-w-prose">
          At AI Montclair, we empower businesses to thrive in the age of AI. Through custom-built automation solutions and hands-on training, we help companies streamline operations, upskill their workforce, and unlock new levels of productivity and profitability. We're not just delivering tools—we're building capabilities.
        </p>
      </div>
    </div>
  </section>
);

export default Mission;